<div>
  <app-components-togglepanel [(isOpen)]="isOpen" title="Email Settings" toggleBody="true">
    <ng-container>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label">Onboarding Recap Email Action items</label>
            <quill-editor [modules]="quillModules" [theme]="'snow'" style="height: 150px;" [(ngModel)]="onboardingRecapEmailActionItems"></quill-editor>
          </div>
        </div>
      </div>
    </ng-container>
  </app-components-togglepanel>
</div>